// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-2ae00fba] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-sidebar-tabs[data-v-2ae00fba] {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 100%;
}
.app-sidebar-tabs__nav[data-v-2ae00fba] {
  display: flex;
  justify-content: stretch;
  margin: 10px 8px 0;
  border-bottom: 1px solid var(--color-border);
}
.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant {
  border: unset !important;
  border-radius: 0 !important;
}
.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant .checkbox-content {
  padding: var(--default-grid-baseline);
  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0 !important;
  margin: 0 !important;
  border-bottom: var(--default-grid-baseline) solid transparent !important;
}
.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant .checkbox-content .checkbox-content__icon--checked > * {
  color: var(--color-main-text) !important;
}
.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant.checkbox-radio-switch--checked .checkbox-radio-switch__content {
  background: transparent !important;
  color: var(--color-main-text) !important;
  border-bottom: var(--default-grid-baseline) solid var(--color-primary-element) !important;
}
.app-sidebar-tabs__tab[data-v-2ae00fba] {
  flex: 1 1;
}
.app-sidebar-tabs__tab.active[data-v-2ae00fba] {
  color: var(--color-primary-element);
}
.app-sidebar-tabs__tab-caption[data-v-2ae00fba] {
  flex: 0 1 100%;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.app-sidebar-tabs__tab-icon[data-v-2ae00fba] {
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 20px;
}
.app-sidebar-tabs__tab[data-v-2ae00fba] .checkbox-radio-switch__content {
  max-width: unset;
}
.app-sidebar-tabs__content[data-v-2ae00fba] {
  position: relative;
  min-height: 256px;
  height: 100%;
}
.app-sidebar-tabs__content--multiple[data-v-2ae00fba] > :not(section) {
  display: none;
}
.material-design-icon[data-v-90858b97] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-sidebar[data-v-90858b97] {
  z-index: 1500;
  top: 0;
  right: 0;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  flex-shrink: 0;
  width: 27vw;
  min-width: 300px;
  max-width: 500px;
  height: 100%;
  border-left: 1px solid var(--color-border);
  background: var(--color-main-background);
}
.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97] {
  position: absolute;
  z-index: 100;
  top: 6px;
  right: 6px;
  width: 44px;
  height: 44px;
  opacity: .7;
  border-radius: 22px;
}
.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97]:hover,
.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97]:active,
.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97]:focus {
  opacity: 1;
  background-color: #7f7f7f40;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info[data-v-90858b97] {
  flex-direction: row;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__figure[data-v-90858b97] {
  z-index: 2;
  width: 70px;
  height: 70px;
  margin: 9px;
  border-radius: 3px;
  flex: 0 0 auto;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc[data-v-90858b97] {
  padding-left: 0;
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 94px;
  padding-top: 10px;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-90858b97] {
  padding-right: 50px;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-90858b97] {
  z-index: 3;
  position: absolute;
  top: 9px;
  left: -44px;
  gap: 0;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__menu[data-v-90858b97] {
  top: 6px;
  right: 50px;
  background-color: transparent;
  position: absolute;
}
.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__menu[data-v-90858b97] {
  position: absolute;
  top: 6px;
  right: 50px;
}
.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc[data-v-90858b97] {
  padding-right: 94px;
}
.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-90858b97] {
  padding-right: 50px;
}
.app-sidebar .app-sidebar-header .app-sidebar-header__info[data-v-90858b97] {
  display: flex;
  flex-direction: column;
}
.app-sidebar .app-sidebar-header__figure[data-v-90858b97] {
  width: 100%;
  height: 250px;
  max-height: 250px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.app-sidebar .app-sidebar-header__figure--with-action[data-v-90858b97] {
  cursor: pointer;
}
.app-sidebar .app-sidebar-header__desc[data-v-90858b97] {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 18px 6px 18px 9px;
  gap: 0 4px;
}
.app-sidebar .app-sidebar-header__desc--with-tertiary-action[data-v-90858b97] {
  padding-left: 6px;
}
.app-sidebar .app-sidebar-header__desc--editable .app-sidebar-header__mainname-form[data-v-90858b97],
.app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__mainname-form[data-v-90858b97] {
  margin-top: -2px;
  margin-bottom: -2px;
}
.app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__subname[data-v-90858b97] {
  margin-top: -2px;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-90858b97] {
  display: flex;
  height: 44px;
  width: 44px;
  justify-content: center;
  flex: 0 0 auto;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-90858b97] {
  box-shadow: none;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-90858b97]:not([aria-pressed=true]):hover {
  box-shadow: none;
  background-color: var(--color-background-hover);
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container[data-v-90858b97] {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container[data-v-90858b97] {
  display: flex;
  align-items: center;
  min-height: 44px;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-90858b97] {
  padding: 0;
  min-height: 30px;
  font-size: 20px;
  line-height: 30px;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-90858b97] .linkified {
  cursor: pointer;
  text-decoration: underline;
  margin: 0;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form[data-v-90858b97] {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form input.app-sidebar-header__mainname-input[data-v-90858b97] {
  flex: 1 1 auto;
  margin: 0;
  padding: 7px;
  font-size: 20px;
  font-weight: 700;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__menu[data-v-90858b97] {
  height: 44px;
  width: 44px;
  border-radius: 22px;
  background-color: #7f7f7f40;
  margin-left: 5px;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname[data-v-90858b97],
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-90858b97] {
  overflow: hidden;
  width: 100%;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-90858b97] {
  padding: 0;
  opacity: .7;
  font-size: var(--default-font-size);
}
.app-sidebar .app-sidebar-header__description[data-v-90858b97] {
  display: flex;
  align-items: center;
  margin: 0 10px;
}
@media only screen and (max-width: 768px) {
  .app-sidebar[data-v-90858b97] {
    width: 100vw;
    max-width: 100vw;
  }
}
.slide-right-leave-active[data-v-90858b97],
.slide-right-enter-active[data-v-90858b97] {
  transition-duration: var(--animation-quick);
  transition-property: max-width, min-width;
}
.slide-right-enter-to[data-v-90858b97],
.slide-right-leave[data-v-90858b97] {
  min-width: 300px;
  max-width: 500px;
}
.slide-right-enter[data-v-90858b97],
.slide-right-leave-to[data-v-90858b97] {
  min-width: 0 !important;
  max-width: 0 !important;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-sidebar-header__description button,
.app-sidebar-header__description .button,
.app-sidebar-header__description input[type=button],
.app-sidebar-header__description input[type=submit],
.app-sidebar-header__description input[type=reset] {
  padding: 6px 22px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-3d1ccc15.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,uFAAuF;EACvF,oBAAoB;EACpB,wEAAwE;AAC1E;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,yFAAyF;AAC3F;AACA;EACE,SAAS;AACX;AACA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,MAAM;EACN,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;;;EAGE,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,MAAM;AACR;AACA;EACE,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;;EAEE,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;;;EAKE,iBAAiB;AACnB","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-2ae00fba] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-sidebar-tabs[data-v-2ae00fba] {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1 1 100%;\n}\n.app-sidebar-tabs__nav[data-v-2ae00fba] {\n  display: flex;\n  justify-content: stretch;\n  margin: 10px 8px 0;\n  border-bottom: 1px solid var(--color-border);\n}\n.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant {\n  border: unset !important;\n  border-radius: 0 !important;\n}\n.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant .checkbox-content {\n  padding: var(--default-grid-baseline);\n  border-radius: var(--default-grid-baseline) var(--default-grid-baseline) 0 0 !important;\n  margin: 0 !important;\n  border-bottom: var(--default-grid-baseline) solid transparent !important;\n}\n.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant .checkbox-content .checkbox-content__icon--checked > * {\n  color: var(--color-main-text) !important;\n}\n.app-sidebar-tabs__nav[data-v-2ae00fba] .checkbox-radio-switch--button-variant.checkbox-radio-switch--checked .checkbox-radio-switch__content {\n  background: transparent !important;\n  color: var(--color-main-text) !important;\n  border-bottom: var(--default-grid-baseline) solid var(--color-primary-element) !important;\n}\n.app-sidebar-tabs__tab[data-v-2ae00fba] {\n  flex: 1 1;\n}\n.app-sidebar-tabs__tab.active[data-v-2ae00fba] {\n  color: var(--color-primary-element);\n}\n.app-sidebar-tabs__tab-caption[data-v-2ae00fba] {\n  flex: 0 1 100%;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n.app-sidebar-tabs__tab-icon[data-v-2ae00fba] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-size: 20px;\n}\n.app-sidebar-tabs__tab[data-v-2ae00fba] .checkbox-radio-switch__content {\n  max-width: unset;\n}\n.app-sidebar-tabs__content[data-v-2ae00fba] {\n  position: relative;\n  min-height: 256px;\n  height: 100%;\n}\n.app-sidebar-tabs__content--multiple[data-v-2ae00fba] > :not(section) {\n  display: none;\n}\n.material-design-icon[data-v-90858b97] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-sidebar[data-v-90858b97] {\n  z-index: 1500;\n  top: 0;\n  right: 0;\n  display: flex;\n  overflow-x: hidden;\n  overflow-y: auto;\n  flex-direction: column;\n  flex-shrink: 0;\n  width: 27vw;\n  min-width: 300px;\n  max-width: 500px;\n  height: 100%;\n  border-left: 1px solid var(--color-border);\n  background: var(--color-main-background);\n}\n.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97] {\n  position: absolute;\n  z-index: 100;\n  top: 6px;\n  right: 6px;\n  width: 44px;\n  height: 44px;\n  opacity: .7;\n  border-radius: 22px;\n}\n.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97]:hover,\n.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97]:active,\n.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-90858b97]:focus {\n  opacity: 1;\n  background-color: #7f7f7f40;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info[data-v-90858b97] {\n  flex-direction: row;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__figure[data-v-90858b97] {\n  z-index: 2;\n  width: 70px;\n  height: 70px;\n  margin: 9px;\n  border-radius: 3px;\n  flex: 0 0 auto;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc[data-v-90858b97] {\n  padding-left: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  padding-right: 94px;\n  padding-top: 10px;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-90858b97] {\n  padding-right: 50px;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-90858b97] {\n  z-index: 3;\n  position: absolute;\n  top: 9px;\n  left: -44px;\n  gap: 0;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__menu[data-v-90858b97] {\n  top: 6px;\n  right: 50px;\n  background-color: transparent;\n  position: absolute;\n}\n.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__menu[data-v-90858b97] {\n  position: absolute;\n  top: 6px;\n  right: 50px;\n}\n.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc[data-v-90858b97] {\n  padding-right: 94px;\n}\n.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-90858b97] {\n  padding-right: 50px;\n}\n.app-sidebar .app-sidebar-header .app-sidebar-header__info[data-v-90858b97] {\n  display: flex;\n  flex-direction: column;\n}\n.app-sidebar .app-sidebar-header__figure[data-v-90858b97] {\n  width: 100%;\n  height: 250px;\n  max-height: 250px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.app-sidebar .app-sidebar-header__figure--with-action[data-v-90858b97] {\n  cursor: pointer;\n}\n.app-sidebar .app-sidebar-header__desc[data-v-90858b97] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 18px 6px 18px 9px;\n  gap: 0 4px;\n}\n.app-sidebar .app-sidebar-header__desc--with-tertiary-action[data-v-90858b97] {\n  padding-left: 6px;\n}\n.app-sidebar .app-sidebar-header__desc--editable .app-sidebar-header__mainname-form[data-v-90858b97],\n.app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__mainname-form[data-v-90858b97] {\n  margin-top: -2px;\n  margin-bottom: -2px;\n}\n.app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__subname[data-v-90858b97] {\n  margin-top: -2px;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-90858b97] {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-90858b97] {\n  box-shadow: none;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-90858b97]:not([aria-pressed=true]):hover {\n  box-shadow: none;\n  background-color: var(--color-background-hover);\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container[data-v-90858b97] {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container[data-v-90858b97] {\n  display: flex;\n  align-items: center;\n  min-height: 44px;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-90858b97] {\n  padding: 0;\n  min-height: 30px;\n  font-size: 20px;\n  line-height: 30px;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-90858b97] .linkified {\n  cursor: pointer;\n  text-decoration: underline;\n  margin: 0;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form[data-v-90858b97] {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form input.app-sidebar-header__mainname-input[data-v-90858b97] {\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 7px;\n  font-size: 20px;\n  font-weight: 700;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__menu[data-v-90858b97] {\n  height: 44px;\n  width: 44px;\n  border-radius: 22px;\n  background-color: #7f7f7f40;\n  margin-left: 5px;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname[data-v-90858b97],\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-90858b97] {\n  overflow: hidden;\n  width: 100%;\n  margin: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-90858b97] {\n  padding: 0;\n  opacity: .7;\n  font-size: var(--default-font-size);\n}\n.app-sidebar .app-sidebar-header__description[data-v-90858b97] {\n  display: flex;\n  align-items: center;\n  margin: 0 10px;\n}\n@media only screen and (max-width: 768px) {\n  .app-sidebar[data-v-90858b97] {\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n.slide-right-leave-active[data-v-90858b97],\n.slide-right-enter-active[data-v-90858b97] {\n  transition-duration: var(--animation-quick);\n  transition-property: max-width, min-width;\n}\n.slide-right-enter-to[data-v-90858b97],\n.slide-right-leave[data-v-90858b97] {\n  min-width: 300px;\n  max-width: 500px;\n}\n.slide-right-enter[data-v-90858b97],\n.slide-right-leave-to[data-v-90858b97] {\n  min-width: 0 !important;\n  max-width: 0 !important;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-sidebar-header__description button,\n.app-sidebar-header__description .button,\n.app-sidebar-header__description input[type=button],\n.app-sidebar-header__description input[type=submit],\n.app-sidebar-header__description input[type=reset] {\n  padding: 6px 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
